<template>
	<div>
		<div class="basic-container">
			<div class="info-tab-box">
				<div class="tab-title">
					<div class="tab-btn">
						<a class="title" :class="viewType === 'info' ? 'tab-txt-click' : ''" @click="moveTab('info')">
							<img
								:src="
									viewType === 'info'
										? require('../../assets/images/icon/icon-info1@2x.png')
										: require('../../assets/images/icon/icon-info1-no@2x.png')
								"
							/>
							회원정보</a
						>
						<a class="title" :class="viewType === 'certificate' ? 'tab-txt-click' : ''" @click="moveTab('certificate')">
							<img
								:src="
									viewType === 'certificate'
										? require('../../assets/images/icon/icon-info2@2x.png')
										: require('../../assets/images/icon/icon-info2-no@2x.png')
								"
							/>
							회사정보</a
						>
						<a class="title" :class="viewType === 'career' ? 'tab-txt-click' : ''" @click="moveTab('career')">
							<img
								:src="
									viewType === 'career'
										? require('../../assets/images/icon/icon-info3@2x.png')
										: require('../../assets/images/icon/icon-info3-no@2x.png')
								"
							/>
							참여경력</a
						>
					</div>
					<button class="lineBtn" @click="oktaInfo">내정보 수정하기</button>
				</div>

				<div class="tab-title web-hide">
					<a class="title" :class="viewType === 'info' ? 'tab-txt-click' : ''" @click="moveTab('info')">회원정보</a>
					<a class="title" :class="viewType === 'certificate' ? 'tab-txt-click' : ''" @click="moveTab('certificate')">회사정보</a>
					<a class="title" :class="viewType === 'career' ? 'tab-txt-click' : ''" @click="moveTab('career')">참여경력</a>
				</div>
			</div>

			<form name="form" id="oktaUserForm" method="post" enctype="multipart/form-data">
				<section class="mypage-info-area" v-show="viewType == 'info'">
					<div class="block half">
						<label>아이디</label>
						<input type="text" name="userId" v-model="apiData.userId" readonly disabled />
					</div>
					<div class="block half">
						<label class="text-right">회원구분</label>
						<input type="text" name="grdNm" v-model="apiData.userGrd" readonly disabled />
					</div>
					<div class="block half">
						<label>성명(국문)</label>
						<input type="text" name="userNmKor" v-model="apiData.userNmKor" readonly disabled />
					</div>
					<div class="block half">
						<label class="text-right">성명(영문)</label>
						<input type="text" name="userNmEng" v-model="apiData.userNmEng" readonly disabled />
					</div>
					<div class="block half">
						<label>생년월일</label>
						<input type="text" name="birthDate" v-model="apiData.birthDate" readonly disabled />
					</div>
					<div class="block half">
						<label class="text-right">국가 | 지회</label>
						<div class="select-wrapper" style="margin-right: 20px">
							<select name="country" v-model="apiData.country" readonly disabled>
								<option value="" selected>국가</option>
								<option v-for="codeVO in countryList" v-bind:key="codeVO.codeCd" :value="codeVO.codeCd">{{ codeVO.codeNm }}</option>
							</select>
						</div>
						<div class="select-wrapper">
							<select name="region" v-model="apiData.region" readonly disabled>
								<option value="" selected>지회</option>
								<option v-for="codeVO in regionList" v-bind:key="codeVO.codeCd" :value="codeVO.codeCd">{{ codeVO.codeNm }}</option>
							</select>
						</div>
					</div>
					<div class="block half">
						<label>이메일</label>
						<input type="text" name="extraEmail" v-model="apiData.extraEmail" readonly disabled />
					</div>
					<div class="block half">
						<label class="text-right">휴대폰</label>
						<input type="text" name="mobile" v-model="apiData.mobile" readonly disabled />
					</div>
					<div class="block half">
						<label>보조이메일</label>
						<input class="border-open" name="userEmail" v-model="apiData.userEmail" type="text" placeholder="입력해주세요." />
					</div>
					<div class="block half">
						<label class="text-right">일반전화</label>
						<input class="border-open" name="userLandline" v-model="userLandline" type="tel" maxlength="13" placeholder="입력해주세요." />
					</div>
					<div class="block half">
						<label>카톡아이디</label>
						<input type="text" name="kakaoId" v-model="apiData.kakaoId" readonly disabled />
					</div>
					<div class="block half">
						<label class="text-right">사업비 지급계좌<a class="important-icon">*</a></label>
						<file-input-drag
							target-id="ACCOUNT_FILE"
							target-name="ACCOUNT_FILE"
							v-show="apiData.accountFile == null"
							accept="image/jpeg,image/jpg,image/png,.pdf"
							:on-change="addFile"
							:multiple="false"
						/>
						<div v-if="apiData.accountFile" class="info-img-file">
							<a :href="CONST.API_SERVER + '/okta/file/' + apiData.accountFile.split('|')[0]" download
								><div class="file-ellipsis">{{ apiData.accountFile.split('|')[1] }}</div></a
							>
							<img class="icon-trash trash-box" :src="require('../../assets/images/icon/icon-trash@2x.png')" @click="delFile('ACCOUNT_FILE')" />
							<input type="hidden" name="accountFile" v-model="apiData.accountFile" />
						</div>
					</div>
					<div class="block half">
						<label>전자서명이미지<a class="important-icon">*</a></label>
						<file-input-drag
							target-id="SIGN_FILE"
							target-name="SIGN_FILE"
							v-show="apiData.signFile == null"
							accept="image/jpeg,image/jpg,image/png,.pdf"
							:on-change="addFile"
							:multiple="false"
						/>
						<div v-if="apiData.signFile" class="info-img-file">
							<a :href="CONST.API_SERVER + '/okta/file/' + apiData.signFile.split('|')[0]" download
								><div class="file-ellipsis">{{ apiData.signFile.split('|')[1] }}</div></a
							>
							<img class="icon-trash trash-box" :src="require('../../assets/images/icon/icon-trash@2x.png')" @click="delFile('SIGN_FILE')" />
							<input type="hidden" name="signFile" v-model="apiData.signFile" />
						</div>
					</div>
					<div class="block half mobile-hide"></div>
					<div class="text-center web-hide mt-8">
						<button class="lineBtn mr-3" @click.prevent.stop="$router.go(-1)">취소</button>
						<button class="greenBtn" @click.once="doSubmit">저장</button>
					</div>
				</section>

				<section class="mypage-info-area" v-show="viewType == 'certificate'">
					<div class="block half">
						<label>회사명(국문)</label>
						<input type="text" name="companyNmKor" v-model="apiData.companyNmKor" readonly disabled />
					</div>
					<div class="block half">
						<label class="text-right">회사명(영문)</label>
						<input type="text" name="companyNmEng" v-model="apiData.companyNmEng" readonly disabled />
					</div>
					<div class="block half">
						<label>업종</label>
						<input type="text" name="businessTypeNm" v-model="apiData.businessTypeNm" readonly disabled />
					</div>
					<div class="block half">
						<label class="text-right">세부품목</label>
						<input type="text" name="exportProduct" v-model="apiData.exportProduct" readonly disabled />
					</div>
					<div class="block half">
						<label>우편번호</label>
						<input type="text" name="postNo" v-model="apiData.postNo" readonly disabled />
					</div>
					<div class="block half mobile-hide"></div>
					<div class="block">
						<label>주소</label>
						<input type="text" name="companyAddress" v-model="apiData.companyAddress" readonly disabled />
					</div>
					<div class="block">
						<label>홈페이지</label>
						<input type="text" name="website" v-model="apiData.website" readonly disabled />
					</div>
					<div class="block half">
						<label>사업자등록증<a class="important-icon">*</a></label>
						<file-input-drag
							target-id="REGISTRATION_FILE"
							target-name="REGISTRATION_FILE"
							v-show="apiData.registrationFile == null"
							accept="image/jpeg,image/jpg,image/png,.pdf"
							:on-change="addFile"
							:multiple="false"
						/>
						<div v-if="apiData.registrationFile" class="info-img-file">
							<a :href="CONST.API_SERVER + '/okta/file/' + apiData.registrationFile.split('|')[0]" download
								><div class="file-ellipsis">{{ apiData.registrationFile.split('|')[1] }}</div></a
							>
							<img class="icon-trash trash-box" :src="require('../../assets/images/icon/icon-trash@2x.png')" @click="delFile('REGISTRATION_FILE')" />
							<input type="hidden" name="registrationFile" v-model="apiData.registrationFile" />
						</div>
					</div>
					<div class="block half mobile-hide"></div>
					<div class="text-center web-hide mt-8">
						<button class="lineBtn mr-3" @click.prevent.stop="$router.go(-1)">취소</button>
						<button class="greenBtn" @click.once="doSubmit">저장</button>
					</div>
				</section>

				<section class="mypage-info-area" v-show="viewType === 'career'">
					<div class="mypage-info-title">
						<h4 class="mobile-mt-3">수출지원사업 참여경력</h4>
						<div class="title-btn">
							<button type="button" name="addRow" class="greenBtn tiny mr-2" @click="addRow()">+추가</button>
							<button type="button" name="delRow" class="grayBtn tiny" @click="delRow()">-삭제</button>
						</div>
					</div>
					<div v-show="participationCdList.length > 0" v-for="(row, i) in participationCdList" :key="'participationCdList' + i">
						<div class="block half">
							<label>사업명</label>
							<input type="text" class="border-open" v-model="row.PARTICIPATION_TITLE" readonly />
						</div>
						<div class="block half">
							<label class="text-right">사업주관기관</label>
							<input type="text" class="border-open" v-model="row.PARTICIPATION_FROM" readonly />
						</div>
						<div class="block">
							<label>수행기간</label>
							<div class="date-wrapper">
								<Datepicker
									:calendar-button-icon="'fal fa-calendar'"
									:calendar-button="true"
									:format="'yyyy-MM-dd'"
									:language="ko"
									:div-class="'data'"
									:input-class="'dateTypeInput'"
									v-model="row.PARTICIPATION_START_YM"
									disabled
								></Datepicker>
								<span> ~ </span>
								<Datepicker
									:calendar-button-icon="'fal fa-calendar'"
									:calendar-button="true"
									:format="'yyyy-MM-dd'"
									:language="ko"
									:div-class="'data'"
									:input-class="'dateTypeInput'"
									v-model="row.PARTICIPATION_END_YM"
									disabled
								></Datepicker>
							</div>
						</div>
						<div class="block">
							<label>주요성과</label>
							<input type="text" class="border-open" v-model="row.PARTICIPATION_RESULT" readonly />
						</div>
						<div class="block half mobile-hide"></div>
						<div class="mypage-info-title"></div>
					</div>
					<div v-for="(row, i) in historyCdList" :key="'historyCdList' + i">
						<div class="block half">
							<label>사업명<a class="important-icon">*</a></label>
							<input
								type="text"
								class="border-open"
								name="HISTORY_TITLE"
								v-model="row.HISTORY_TITLE"
								:ref="'HISTORY_TITLE' + i"
								placeholder="사업명을 입력해주세요"
							/>
						</div>
						<div class="block half">
							<label class="text-right">사업주관기관<a class="important-icon">*</a></label>
							<input
								type="text"
								class="border-open"
								name="HISTORY_AGENCY"
								v-model="row.HISTORY_AGENCY"
								:ref="'HISTORY_AGENCY' + i"
								placeholder="사업주관기관을 입력해주세요"
							/>
						</div>
						<div class="block">
							<label>수행기간<a class="important-icon">*</a></label>
							<div class="date-wrapper">
								<Datepicker
									:calendar-button-icon="'fal fa-calendar'"
									:calendar-button="true"
									:format="'yyyy-MM-dd'"
									:language="ko"
									:div-class="'data'"
									:input-class="'dateTypeInput'"
									v-model="row.HISTORY_START_YM"
									name="HISTORY_START_YM"
								></Datepicker>
								<span> ~ </span>
								<Datepicker
									:calendar-button-icon="'fal fa-calendar'"
									:calendar-button="true"
									:format="'yyyy-MM-dd'"
									:language="ko"
									:div-class="'data'"
									:input-class="'dateTypeInput'"
									v-model="row.HISTORY_END_YM"
									name="HISTORY_END_YM"
								></Datepicker>
							</div>
						</div>
						<div class="block">
							<label>주요성과<a class="important-icon">*</a></label>
							<input
								type="text"
								class="border-open"
								name="HISTORY_RESULT"
								v-model="row.HISTORY_RESULT"
								:ref="'HISTORY_RESULT' + i"
								placeholder="주요성과를 입력해주세요"
							/>
						</div>
						<div class="block half mobile-hide"></div>
						<div class="mypage-info-title"></div>
					</div>
					<div class="block text-center mobile-hide mt-8">
						<button class="lineBtn mr-3" @click.prevent.stop="reloadPage()">취소</button>
						<button class="greenBtn" @click.once="doSubmit">저장</button>
					</div>
					<div class="text-center web-hide mt-8">
						<button class="lineBtn mr-3" @click.prevent.stop="reloadPage()">취소</button>
						<button class="greenBtn" @click.once="doSubmit">저장</button>
					</div>
				</section>
			</form>
		</div>
	</div>
</template>

<script>
import eventBus from '@/plugins/event-bus';
import CONST from '@/constants';
import FileInputDrag from '@/components/common/FileInputDrag';
import Datepicker from 'vuejs-datepicker';
import { ko } from 'vuejs-datepicker/dist/locale';

export default {
	title: '내정보변경',
	name: 'Mypage-Detail-OktaUser',
	props: ['loginMember', 'onChange', 'tabType'],
	components: { FileInputDrag, Datepicker: Datepicker },
	watch: {
		userLandline: function(v) {
			v = this.$options.filters['phoneNumberOnly'](v);
			this.userLandline = v;
		},
		mobile: function(v) {
			v = this.$options.filters['phoneNumberOnly'](v);
			this.mobile = v;
		},
		viewType: function(e) {
			if (this.onChange) this.onChange(e);
		},
	},
	data: function() {
		return {
			ko: ko,
			CONST: CONST,
			viewType: 'info',
			apiData: [],
			participationCdList: [
				{
					PARTICIPATION_TITLE: '',
					PARTICIPATION_FROM: '',
					PARTICIPATION_START_YM: '',
					PARTICIPATION_END_YM: '',
					PARTICIPATION_RESULT: '',
				},
			],
			historyCdList: [
				{
					HISTORY_TITLE: '',
					HISTORY_AGENCY: '',
					HISTORY_START_YM: '',
					HISTORY_END_YM: '',
					HISTORY_RESULT: '',
				},
			],
			countryList: [],
			regionList: [],
			localLandLineCountryList: [],

			localLandLineCountry: null,
			mobile: '',
			landline: '',
			country: '',
			region: '',
			userLandline: '',
		};
	},
	created() {},
	beforeMount() {
		eventBus.$emit(CONST.EVENTS.SET_SIDE_MENU, 'MYPAGE');
	},
	mounted() {
		this.viewType = this.tabType || 'info';
		eventBus.$on(
			CONST.EVENTS.SAVE_MYPAGE,
			function(v) {
				if (v === CONST.USER_TYPE.OKTA) this.doSubmit();
			}.bind(this),
		);
		eventBus.$on(
			CONST.EVENTS.OPEN_TAB_MENU,
			function(u, v) {
				if (u === CONST.USER_TYPE.OKTA && this.$device.isEmpty(v)) this.moveTab(v);
				this.getOktaUserDetail();
			}.bind(this),
		);
		if (this.apiData.historyCd) this.historyCdRowData = JSON.parse(this.apiData.historyCd);
		this.getCountryList();
		this.getOktaUserDetail();
	},
	beforeDestroy() {
		eventBus.$off(CONST.EVENTS.SAVE_MYPAGE);
		eventBus.$off(CONST.EVENTS.OPEN_TAB_MENU);
	},
	computed: {},
	methods: {
		moveTab: function(tab) {
			this.viewType = tab;
		},
		getCountryList: function() {
			this.countryList = [];
			let formData = new FormData();
			formData.append('parentCodeCd', 'COUNTRY_F_CD');
			this.$apiClient
				.getInstance()
				.post(this.$apiClient.getApiServer() + '/api/common/getMngCodeList.do', formData)
				.then(res => {
					if (res.data.resultCode === 0) {
						this.countryList = res.data.data;
					} else {
						window.alert(res.data.resultMsg);
					}
				})
				.catch(e => console.error(e));
		},
		getRegionList: function(country) {
			this.regionList = [];
			let formData = new FormData();
			formData.append('country', country);
			this.$apiClient
				.getInstance()
				.post(this.$apiClient.getApiServer() + '/api/common/getRegionList.do', formData)
				.then(res => {
					if (res.data.resultCode === 0) {
						this.regionList = res.data.data;
					} else {
						window.alert(res.data.resultMsg);
					}
				})
				.catch(e => console.error(e));
		},
		getOktaUserDetail: function() {
			this.apiData = [];
			let formData = new FormData();
			formData.append('seqNo', this.loginMember.seqNo);
			this.$apiClient
				.getInstance()
				.post(this.$apiClient.getApiServer() + '/api/mypage/getOktaUserDetail.do', formData)
				.then(res => {
					if (res.data.resultCode === 0) {
						if (res.data.data) {
							this.apiData = res.data.data;
							this.country = this.apiData.country;
							this.region = this.apiData.region;
							this.userNm = this.apiData.userNmKor;
							this.historyCdList = JSON.parse(this.apiData.historyCd);
							this.participationCdList = JSON.parse(this.apiData.participationCd);
							if (this.apiData.userLandline != null) this.userLandline = this.apiData.userLandline;
							this.getRegionList(this.apiData.country);
						}
					} else {
						window.alert(res.data.resultMsg);
					}
				})
				.catch(e => console.error(e));
		},
		reloadPage: function() {
			window.location.reload();
		},
		oktaInfo: function() {
			this.$session.set('userId', this.loginMember.userId);
			this.$device.pushView(CONST.CMS_SERVER + '/mypage/myMemberEdit.do' + '?userId=' + this.$apiClient.getApiToken());
		},
		doSubmit: function() {
			if (this.$device.isEmpty(this.apiData.signFile)) {
				window.alert('전자서명이미지 파일을 업로드 해주세요');
				return false;
			}
			if (this.$device.isEmpty(this.apiData.accountFile)) {
				window.alert('사업비 지급계좌 파일을 업로드 해주세요');
				return false;
			}
			if (this.$device.isEmpty(this.apiData.registrationFile)) {
				window.alert('사업자등록증 파일을 업로드 해주세요');
				return false;
			}
			for (let i = 0; i < this.historyCdList.length; i++) {
				if (this.historyCdList[i].HISTORY_TITLE === '') {
					window.alert('사업명을 입력해 주세요');
					this.$refs['HISTORY_TITLE' + i][0].focus();
					return false;
				}
				if (this.historyCdList[i].HISTORY_AGENCY === '') {
					window.alert('사업주관기간을 입력해 주세요');
					this.$refs['HISTORY_AGENCY' + i][0].focus();
					return false;
				}
				if (this.historyCdList[i].HISTORY_START_YM === '') {
					window.alert('사업수행 시작일을 입력해 주세요');
					this.$refs['HISTORY_START_YM' + i][0].focus();
					return false;
				}
				if (this.historyCdList[i].HISTORY_END_YM === '') {
					window.alert('사업수행 종료일을 입력해 주세요');
					this.$refs['HISTORY_END_YM' + i][0].focus();
					return false;
				}
				if (this.historyCdList[i].HISTORY_RESULT === '') {
					window.alert('주요성과를 입력해 주세요');
					this.$refs['HISTORY_RESULT' + i][0].focus();
					return false;
				}
			}

			let form = document.getElementById('oktaUserForm');
			let formData = new FormData(form);
			for (let i = 0; i < this.historyCdList.length; i++) {
				let bufferStartYm = this.$moment(this.historyCdList[i].HISTORY_START_YM).format('YYYY-MM-DD');
				let bufferEndYm = this.$moment(this.historyCdList[i].HISTORY_END_YM).format('YYYY-MM-DD');
				this.historyCdList[i].HISTORY_START_YM = bufferStartYm;
				this.historyCdList[i].HISTORY_END_YM = bufferEndYm;
			}
			this.apiData.historyCd = JSON.stringify(this.historyCdList);
			formData.append('seqNo', this.loginMember.seqNo);
			formData.append('userType', CONST.USER_TYPE.OKTA);
			formData.append('historyCd', this.apiData.historyCd);

			this.$apiClient
				.getInstance()
				.post(this.$apiClient.getApiServer() + '/api/mypage/oktaUser/myPageSubmit.do', formData)
				.then(res => {
					if (res.data.resultCode === 0) {
						alert('저장되었습니다.');
						this.$device.saveLocalData('MY_INFO', JSON.stringify(this.apiData));
						window.location.reload();
					} else {
						window.alert(res.data.resultMsg);
					}
				})
				.catch(e => console.error(e));
		},
		delFile: function(file) {
			if (file === 'ACCOUNT_FILE') this.apiData.accountFile = null;
			if (file === 'SIGN_FILE') this.apiData.signFile = null;
			if (file === 'REGISTRATION_FILE') this.apiData.registrationFile = null;

			let fileInput = document.getElementById(file);
			fileInput.value = null;
		},
		addFile: function(e) {
			// let parent = e.target.parentElement;
			let fileInputName = e.target ? e.target.name : e.name;
			let fileInputList = e.target ? e.target.files : e.files;
			if (fileInputName === 'ACCOUNT_FILE') {
				try {
					let file = fileInputList[0];
					if (file) this.apiData.accountFile = '|' + file.name;
				} catch (e) {
					console.error(e);
				}
			}
			if (fileInputName === 'SIGN_FILE') {
				try {
					let file = fileInputList[0];
					if (file) this.apiData.signFile = '|' + file.name;
				} catch (e) {
					console.error(e);
				}
			}
			if (fileInputName === 'REGISTRATION_FILE') {
				try {
					let file = fileInputList[0];
					if (file) this.apiData.registrationFile = '|' + file.name;
				} catch (e) {
					console.error(e);
				}
			}
		},
		addRow: function() {
			this.historyCdList.push({
				HISTORY_TITLE: '',
				HISTORY_AGENCY: '',
				HISTORY_START_YM: '',
				HISTORY_END_YM: '',
				HISTORY_RESULT: '',
			});
		},
		delRow: function() {
			if (this.historyCdList.length < 1) window.alert('마지막 행입니다');
			else this.historyCdList.pop();
		},
	},
};
</script>

<style scoped></style>
